export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
          关于我们
        </span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          关于6080新视觉影视
        </h2>
        <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
          6080新视觉影视是一个致力于提供<strong>高清电影在线观看</strong>服务的平台。我们汇聚了海量优质影视资源，
          涵盖动作、喜剧、科幻、悬疑、文艺、纪录等多种类型，满足不同观众的观影需求。
        </p>
        <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
          平台采用先进的<strong>超清画质影视</strong>播放技术和<strong>蓝光画质播放</strong>引擎，
          配合全球CDN加速网络，致力于为每一位观众提供流畅、高清、沉浸式的<strong>免费在线观看</strong>体验。
          无需注册、无需付费，打开网页即可享受<strong>高清视频网站</strong>带来的<strong>视觉盛宴</strong>。
        </p>
        <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          我们相信，好的电影应该被更多人看到。6080新视觉影视将持续更新片库，优化播放体验，
          让每一位影迷都能在这里找到属于自己的<strong>视觉体验</strong>和光影世界。
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
          <div className="text-center">
            <span className="block font-heading text-2xl font-bold text-primary-500">10万+</span>
            <span className="text-xs text-foreground-600">影片资源</span>
          </div>
          <div className="text-center">
            <span className="block font-heading text-2xl font-bold text-accent-500">24个</span>
            <span className="text-xs text-foreground-600">类型覆盖</span>
          </div>
          <div className="text-center">
            <span className="block font-heading text-2xl font-bold text-secondary-500">每日</span>
            <span className="text-xs text-foreground-600">动态更新</span>
          </div>
        </div>
      </div>
    </section>
  );
}